import {STATUS_VOID} from './status-types';

export const SHOW_TOAST_STATUS_LIST = [STATUS_VOID];
